import React, { useState } from 'react'
import { workers, initialTasks } from './data/mockData.js';
import { styles } from './styles/styles.js';
import { Plus } from 'lucide-react';
import OverviewPage from './components/OverviewPage.js';
import TasksPage from './components/TasksPage.js';
import WorkersPage from './components/WorkersPage.js';
import AddTaskModal from './components/AddTaskModal.js';

function HouseKeeping() {
  const [activeTab, setActiveTab] = useState('overview');
  const [showAddModal, setShowAddModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState('All Status');
  const [priorityFilter, setPriorityFilter] = useState('All Priority');
  const [dateFilter, setDateFilter] = useState('');

  const [tasks, setTasks] = useState(initialTasks);

  const [newTask, setNewTask] = useState({
    title: '',
    description: '',
    location: '',
    assignedTo: '',
    priority: 'medium',
    dueDate: '',
    estimatedTime: 30
  });
  const handleAddTask = () => {
    if (newTask.title && newTask.assignedTo && newTask.location && newTask.dueDate) {
      const task = {
        ...newTask,
        id: Date.now(),
        status: 'pending',
        assignedTo: parseInt(newTask.assignedTo)
      };
      setTasks([...tasks, task]);
      setNewTask({
        title: '',
        description: '',
        location: '',
        assignedTo: '',
        priority: 'medium',
        dueDate: '',
        estimatedTime: 30
      });
      setShowAddModal(false);
    }
  };

  // Delete task
  const handleDeleteTask = (taskId) => {
    setTasks(tasks.filter(task => task.id !== taskId));
  };

  // Update task status
  const handleStatusChange = (taskId, newStatus) => {
    setTasks(tasks.map(task =>
      task.id === taskId ? { ...task, status: newStatus } : task
    ));
  };


  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.headerInner}>
            <div>
              <h1 style={styles.headerTitle}>Housekeeping Dashboard</h1>
              <p style={styles.headerSubtitle}>Manage cleaning tasks and staff assignments</p>
            </div>
            <button
              style={styles.addBtn}
              onClick={() => setShowAddModal(true)}
              onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#16a34a'}
            >
              <Plus size={20} />
              Add Task
            </button>
          </div>
        </div>
      </div>
      <div style={styles.navContainer}>
        <div style={styles.navTabs}>
          {['overview', 'tasks', 'workers'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              style={{
                ...styles.navTab,
                ...(activeTab === tab ? styles.navTabActive : styles.navTabInactive)
              }}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
      <div style={styles.mainContent}>
        {activeTab === 'overview' && (
          <OverviewPage tasks={tasks} workers={workers} />
        )}
        {/*  */}
        {activeTab === 'tasks' && (
          <TasksPage
            tasks={tasks}
            workers={workers}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            priorityFilter={priorityFilter}
            setPriorityFilter={setPriorityFilter}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            onDeleteTask={handleDeleteTask}
            onStatusChange={handleStatusChange}
          />
        )}
        {activeTab === 'workers' && (
          <WorkersPage
            workers={workers}
            tasks={tasks}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
          />
        )}
      </div>
      <AddTaskModal
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        newTask={newTask}
        setNewTask={setNewTask}
        workers={workers}
        onAddTask={handleAddTask}
      />

    </div>
  )
}

export default HouseKeeping